__webpack_require__.p = "https://asset-2025.tuwan.com/activity/vip/dist/";